import React from 'react'
import {Container, Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button} from '../../../../../gori/widgets'
import {A1_CONSTANTS} from '../../../a1'

type Props = {
  data: {
    type: string
    reason: string
    first_release_status: string
  } | null
  show: boolean
  handleClose: any
}

const ReasonModal: React.FC<Props> = ({data, show, handleClose}) => {
  const intl = useIntl()

  return (
    <Modal
      id='gori_modal_hold_order_reason'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='mw-600px h-auto'
      show={show}
      backdrop='static'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <Modal.Header closeButton>
          <Modal.Title bsPrefix={'fw-bolder fs-1'}>
            {intl.formatMessage({
              id: `${data?.first_release_status?.toUpperCase()}_ORDER_REASON`,
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <>
              <div>
                <strong className='me-1'>
                  {intl.formatMessage({
                    id: `${
                      data?.first_release_status === A1_CONSTANTS.OPTIONS_RELEASE_STATUS.HOLD.value
                        ? 'HOLD'
                        : 'REJECTION'
                    }_TYPE`,
                  })}
                  :
                </strong>
                <span>{data?.type}</span>
              </div>
              {!!data?.reason && <div className='mt-4'>{data?.reason}</div>}
            </>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <div className='row'>
            <div className='d-flex justify-content-end'>
              <Button
                className='btn btn-secondary me-3'
                label={intl.formatMessage({id: 'CLOSE'})}
                event={handleClose}
              />
            </div>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

export {ReasonModal}
